export default "__VITE_PUBLIC_ASSET__b21c2130__"